export enum BUTTON_TYPES {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  GOOGLE = 'google',
  GRAY = 'gray',
  ERROR = 'error',
  SUCCESS = 'success',
}

export enum INPUT_TYPES {
  TEXT = 'text',
  EMAIL = 'email',
  PASSWORD = 'password',
  DATE = 'date',
  FILE = 'file',
  PHONE = 'phone'
}

export enum ALERT_TYPES {
  ERROR = 'error',
  SUCCESS = 'success'
}

export enum ROUTES {
  MAIN = '/',
  PRODUCT = '/product',
  ABOUT_US = '/about',
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  APPLICATIONS = '/applications',
  CLIENT_PRODUCT = '/client-product',
  STATISTICS = '/statistics',
  RESET_PASSWORD = '/reset',
  SET_NEW_PASSWORD = '/reset/:token',
  ACTIVATE_EMAIL = '/activate/:uid/:token'
}

export enum LS_KEYS {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
}

export enum FIELDS_TYPES {
  INN = 'inn',
  REGION = 'region',
  NUMBER = 'number',
  SELECT = 'select',
  PHONE = 'phone',
  DATE = 'date',
  STRING = 'string'
}

export enum TABLE_STATUSES {
  OPENED = 'opened',
  PENDING = 'pending',
  CLOSED = 'closed'
}

export enum INPUT_PLACEHOLDERS {
  PHONE = '89091234567',
}

export enum PAGINATION {
  PAGE_SIZE = 8
}

export enum MODAL_STEPS {
  CHOOSE_BANK_AND_PRODUCT = 'bank and product',
  FIELDS = 'fields'
}

export interface IUser {
  credit_card_last?: string;
  email?: string;
  fio?: string;
  form?: string | null;
  is_agent?: boolean;
  phone_number?: string;
  username?: string;
}

export interface IApplications {
  count: number;
  next: null;
  previous: null;
  results:  IResult[];
}

export interface IResult {
  name:string;
  bank: string;
  opened?: string | undefined;
  created?: string | undefined;
  scoring_info?: {
    scoring: string;
    inn: string;
    phone: string;
  } | null;
  organisation: string | null;
  status: {
    label: string;
    status: string;
  };
  reward: string;
}

export interface IProductsList {
  banks: IBank[];
}

export interface IBank {
  id:    number;
  name:  string;
  types: IType[];
}

export interface IType {
  name:  string;
  label: string;
}

export interface IFormFields {
  product_id: number;
  bank: string;
  bank_id: number;
  name: string;
  description?: string;
  product_type: string;
  fields: IField[];
}

export interface IField {
  name: string;
  label: string;
  type: string;
  required?: boolean;
  region?: Array<string>;
  options?: Array<string>;
}

